import React from 'react';

export default function EmptyPromptPreview() {
  return (
    <div className="h-full w-full content-center text-center font-bold dark:text-gray-200">
      Select or Create a Prompt
    </div>
  );
}
